module.exports = __webpack_public_path__ + "static/media/Claro-logo.cd9c8aeb.svg";